import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseService } from '../../services/base.service';
import { NotificationService } from '../../services/notifications.service';
import { activeTranslations } from '../../enum/constants';

@Component({
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChannelComponent {
  constructor(
    public dialogRef: MatDialogRef<ChannelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
  ) {}

  save() {
    if (!this.data.channel.trim()) {
      this.notificationService.showError(
        '',
        activeTranslations.notifications_texts.error.empty_channel,
      );
    } else {
      this.dialogRef.close(this.data.channel);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
